import { 
  EpDevPPluginIds 
} from '../constants';
import { EpDevPApiClientBase } from './EpDevPApiClientBase';

/**
 * Base class for EpDevP api clients.
 */
export class EpDevPApiClient extends EpDevPApiClientBase {

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    super({ ...options, pluginId: EpDevPPluginIds.EpDevPPluginId });
  }

}